// extracted by mini-css-extract-plugin
export default {"container":"OrderModal_container__5sNrE","closeModal":"OrderModal_closeModal__xBOtW","modalContainer":"OrderModal_modalContainer__OoIPT"};